<template>
  <div>
    <button class="lillan-header__button"
        v-html="require('!raw-loader!../images/header-menu.svg').default"
        v-on:click="modalOpen = true">
    </button>

    <MountingPortal mountTo="body" name="source" append>
      <transition name="side">
        <div class="lillan-menu-sidebar" v-if="modalOpen" v-on:click.self="modalOpen = false">
          <div class="lillan-menu-sidebar__inner" v-scroll-lock="true">

            <div class="lillan-menu-sidebar__language-switcher">
              <a v-bind:href="language.url" class="lillan-menu-sidebar__language-switcher-item" v-for="language in context.languages" v-bind:class="{'lillan-menu-sidebar__language-switcher-item--active': language['current_lang']}">
                {{ language.slug }}
              </a>
            </div>

            <div class="lillan-menu-sidebar__items">
              <div v-for="item in context.menu" class="lillan-menu-sidebar__item">
                <a v-bind:href="item.url">{{ item.item_title }}</a>
              </div>
            </div>

            <div class="lillan-menu-sidebar__address wysiwyg" v-html="context.address" v-if="context.address"></div>
            <div class="lillan-menu-sidebar__social-icons">

              <a class="lillan-menu-sidebar__social-icon"
                  v-bind:href="context.twitter_link"
                  target="_blank"
                  v-if="context.twitter_link"
                  v-html="require('!raw-loader!../elements/footer/icon-twitter.svg').default">
              </a>

              <a class="lillan-menu-sidebar__social-icon"
                  v-bind:href="context.facebook_link"
                  target="_blank"
                  v-if="context.facebook_link"
                  v-html="require('!raw-loader!../elements/footer/icon-facebook.svg').default">
              </a>

              <a class="lillan-menu-sidebar__social-icon"
                  v-bind:href="context.instagram_link"
                  target="_blank"
                  v-if="context.instagram_link"
                  v-html="require('!raw-loader!../elements/footer/icon-instagram.svg').default">
              </a>

              <a class="lillan-menu-sidebar__social-icon"
                  v-bind:href="context.linkedin_link"
                  target="_blank"
                  v-if="context.linkedin_link"
                  v-html="require('!raw-loader!../elements/footer/icon-linkedin.svg').default">
              </a>

            </div>
            <div class="lillan-menu-sidebar__hkt-container">
              <a class="lillan-menu-sidebar__hkt" v-bind:href="context.primary_nav_hkt_link" v-if="context.primary_nav_hkt_link">
                <img data-sizes="auto" class="lazyload" v-bind:data-src="require('./footer/hkt-logo.png')" v-bind:data-srcset="`${require('./footer/hkt-logo.png')} 100w, ${require('./footer/hkt-logo-2x.png')} 200w`">
              </a>
            </div>
            <button class="lillan-menu-sidebar__close-button"
                v-html="require('!raw-loader!../images/sidebar-close-icon.svg').default"
                v-on:click="modalOpen = false">
            </button>
          </div>

        </div>
      </transition>
      <transition name="fade">
        <div class="lillan-menu-shade"
            v-if="modalOpen"
        ></div>
      </transition>
    </MountingPortal>
  </div>
</template>

<script>
export default {
  props: [ 'context' ],
  data: function() {
    return {
      modalOpen: false,
    };
  },
};
</script>
